<template>
  <q-card :flat="$q.screen.lt.md">
    <q-card-section align="center" class="q-pa-xs" v-if="items && items.length>0">
      <q-avatar dir="ltr" size="lg" color="indigo" text-color="white" >
        <span class="text-subtitle2"> {{ items[items.length - 1].NewCustomer }}</span>
      </q-avatar>
      <q-icon
          v-if="items.length>1"
          :name="(items[items.length - 1].NewCustomer) > (items[items.length - 2].NewCustomer)?'arrow_upward':'south'"
              :color="(items[items.length - 1].NewCustomer) > (items[items.length - 2].NewCustomer)?'green':'red'" size="lg">
        <q-tooltip>
          نسبت به ماه گذشته
        </q-tooltip>
      </q-icon>
      <q-space/>
      <q-chip clickable color="brown" text-color="white" square label="مشتری جدید"/>
    </q-card-section>
    <q-tooltip content-class="bg-transparent text-black">
      <q-card flat bordered>
        <q-card-section>
          <LineChart :items="items" :data="items.map(item => item.NewCustomer)"
                     title="مقایسه مشتریان جدید در سال"/>
        </q-card-section>
      </q-card>
    </q-tooltip>
  </q-card>
</template>

<script>
import LineChart from "@/components/OrderTrace/LineChart";
export default {
  name: "NewCustomerNotActive",
  components: {LineChart},
  props: {
    items: {
      type: Array,
      required: false,
      default:() => []
    }
  },
  data() {
    return {
      orderChartOptions: {
        chart: {
          id: 'vuechart-example',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        plotOptions:{
          bar:{
            borderRadius: 4,
            horizontal: true
          }
        },
        title: {
          text: 'مقایسه سرعت فروش ماهیانه  در سال جاری',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
          },
          categories: []
        },
      },
      orderChartSeries: [{
        name: 'مقدار',
        data: []
      }],
    }
  },
  created() {
    this.orderChartSeries = [{
      data: this.items.map(item => item.Velocity)
    }]
  }
}
</script>

<style scoped>

</style>